import { Button, Inline } from "@adfenix/alexandria";
import { TemplateUiModel } from "routes/back-office/program-builder/details/campaign/meta/template/TemplateUiModel";

interface Props {
  template: TemplateUiModel;
  onPreview: (id: string) => void;
  onDelete: () => void;
  disabled?: boolean;
}

export const TemplateActions = ({
  template,
  onPreview,
  onDelete,
  disabled
}: Props) => {
  return (
    <Inline gap="xs">
      <Button
        logLabel="preview-template-button"
        disabled={disabled ?? false}
        variant="secondary"
        onClick={() => onPreview(template.id)}
        id={`preview-button-${template.id}`}
      >
        <i className={"uil uil-eye"} />
      </Button>

      <Button
        logLabel="delete-template-button"
        disabled={disabled ?? false}
        variant="secondary"
        onClick={onDelete}
      >
        <i className="uil uil-trash-alt" />
      </Button>
    </Inline>
  );
};
